import Repository from './Repository';
import { UpdateNutrientSource } from '@/models/NutrientSource/UpdateNutrientSource';
import {CategorizedNutrients} from "@/models/Nutrient/CategorizedNutrients";
import {MethodResult} from "@/utils/API/ResultTypes/MethodResult";


const resource = '/nutrients';

export default {
  fetchNutrientSourcesList() {
    return Repository.get(`${resource}/ListNutrientSources`, {withCredentials: true});
  },
  updateNutrientSource(updateNutrientSource: UpdateNutrientSource) {
    return Repository.post(`${resource}/updatenutrientsource`, updateNutrientSource, {withCredentials: true});
  },
  listNutrients() {
    return Repository.get<MethodResult<CategorizedNutrients>>(
      `${resource}/ListNutrients`,
      {withCredentials: true}
    );
  }
};
